export const MIN_YEAR = 2020

export const VARIABLES_CONFIG = [
    { folder: '25', id: 47, nombre: 'Temperatura del Aire',              unidad: '°C'    },
    { folder: '26', id: 21, nombre: 'Heliofanía',                        unidad: 'hs'    },
    { folder: '27', id: 94, nombre: 'Precipitación Acumulada Horaria',   unidad: 'mm'    },
    { folder: '28', id: 45, nombre: 'Presión Atm. a Nivel del Mar',      unidad: 'hPa'   },
    { folder: '29', id: 8,  nombre: 'Dirección del Viento',              unidad: 'grados'},
    { folder: '30', id: 29, nombre: 'Intensidad de Viento',              unidad: 'km/h'  },
    { folder: '31', id: 25, nombre: 'Humedad Relativa',                  unidad: '%'     },
]
